module.exports = __webpack_public_path__ + "vrsafety/static/media/Video_Small.951e8741.png";